/** Original AudioClips recovered from the HumanMuseum Unity player. */
export const UNITY_AUDIO = {
  menu: { src: '/assets/unity-audio/Menu.mp3', volume: 0.2 },
  visit: { src: '/assets/unity-audio/Gameplay.mp3', volume: 0.2 },
  result: { src: '/assets/unity-audio/Result.mp3', volume: 0.2 },
  opening: { src: '/assets/unity-audio/MenuOpening.mp3', volume: 1 },
} as const
